export default {
	setActiveCard(state, payload) {
		state.activeCard = payload;
	},

	setActiveContentTitle(state, payload) {
		state.activeContent.title = payload;
	},

	setActiveContentError(state, payload) {
		state.activeContent.error = payload;
	},

	setActiveContentMessage(state, payload) {
		state.activeContent.message = payload;
	},

	setActiveIntegration(state, payload) {
		state.activeContent.integration = payload;
	},

	setAddingIntegration(state, payload) {
		state.addingIntegration = payload;
	},

	setEditingIntegration(state, payload) {
		state.editingIntegration = payload;
	},

	setIsDeleting(state, payload) {
		state.isDeleting = payload;
	},

	providers(state, payload) {
		this._vm.$set(state, 'providers', [...payload]);
	},

	integrations(state, payload) {
		this._vm.$set(state, 'integrations', [...payload]);
	},

	featuredProviders(state, payload) {
		this._vm.$set(state, 'featuredProviders', [...payload]);
	},

	setSearch(state, payload) {
		state.search = payload;
	},

	setFilter(state, payload) {
		state.filters.push(payload);
	},

	clearFilter(state) {
		state.filters = [];
	},

	clearSearch(state) {
		state.search = '';
	},

	setOauthActive(state, payload) {
		state.oauthActive = payload;
	},

	setSearchResults(state, payload) {
		state.searchResults = payload;
	},

	addToSearchResults(state, slug) {
		if (-1 === state.searchResults.indexOf(slug)) {
			state.searchResults.push(slug);
		}
	},

	removeFromSearchResults(state, slug) {
		state.searchResults = state.searchResults.filter((s) => {
			return s !== slug;
		});
	},
};
